import { createUseStyles } from '../../theme/theming';

const useAboutInstituteStyles = createUseStyles((theme) => ({
  aboutInstText: {
    alignSelf: 'center',
    color: 'var(--Black, #0A1629)',
    fontSize: '24px',
    fontWeight: '400',
    fontFamily: theme?.typography?.fontFamily
  },
  metaChild: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    fontFamily: theme?.typography?.fontFamily
  },
  aboutInstWrapper: {
    padding: '64px 128px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    background: '#FFF',
    fontFamily: theme?.typography?.fontFamily
  },
  abtoutInstText: {
    color: theme?.palette?.font?.secondary,
    fontWeight: '400',
    fontSize: theme.typography.fontSize.subHead,
    lineHeight: '20px',
    textAlign: 'center',
    textTransform: 'uppercase',
    wordBreak: 'break-word'
  },

  aboutInstHeader: {
    fontSize: theme.typography.fontSize.h2,
    color: theme?.palette?.font?.default,
    margin: '0px',
    marginBottom: '56px',
    textAlign: 'center'
  },
  imageContainer: {
    width: '240px',
    height: '240px',
    position: 'relative'
    // borderRadius: '16px',
    // border: '1px solid var(--stroke, #D8E0F0)',
  },

  image: {
    width: '100%',
    height: '100%',
    borderRadius: '16px',
    border: '1px solid var(--stroke, #D8E0F0)'
  },

  infoContainer: {
    padding: '24px',
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    background: 'var(--Blue-Tertiary, #F4F9FF)',
    flex: 1
  },

  metaInfo: {
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap'
  },

  metaInfoChild: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px'
  },

  contentWrapper: {
    display: 'flex',
    gap: '24px',
    marginBottom: '24px'
  },

  cardWrapper: {
    // display: 'flex',
    // width: '100%',
    // gap: '24px'
    display: 'flex',
    gap: '24px',
    flex: 1,
    lineHeight: 'normal'
  },

  card: {
    padding: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '16px',
    background: 'var(--Blue-Tertiary, #F4F9FF)',
    flexGrow: 1
  },

  cardDesc: {
    display: 'flex',
    flexDirection: 'column'
  },

  infoDetails: {
    display: 'flex',
    flexDirection: 'Column',
    gap: '10px',
    lineHeight: 'normal'
  },

  infoContent: {
    display: 'flex',
    flexDirection: 'Column',
    gap: '8px'
  },

  instHeading: {
    color: 'var(--Black, #0A1629)',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: '600'
  },

  aboutText: {
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600'
  },

  instAbout: {
    fontFamily: theme?.typography?.fontFamily,
    lineHeight: '22px',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    wordBreak: 'break-word'
  },

  highlightText: {
    color: 'var(--Black, #0A1629)',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '600',
    wordBreak: 'break-word'
  },

  highlightHeading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400'
  },

  // SMALL SCREEN
  '@media screen and (max-width: 767px)': {
    aboutInstText: {
      fontSize: '16px'
    },
    imageContainer: {
      height: '150px',
      width: '150px'
    },
    image: {
      borderRadius: '10px',
      border: '1px solid var(--stroke, #D8E0F0)'
    },
    infoContainer: {
      gap: '16px'
    },
    instHeading: {
      fontSize: '24px'
    },
    cardWrapper: {
      flexDirection: 'column',
      gap: '8px',
      lineHeight: 'normal'
    },
    aboutInstWrapper: {
      padding: '16px'
    },
    aboutInstHeader: {
      color: theme?.palette?.font?.default,
      margin: '0px 0 24px 0',
      textAlign: 'center',
      fontSize: '20px'
    },
    contentWrapper: {
      gap: '8px'
    },
    card: {
      padding: '16px'
    },
    infoDetails: {
      gap: '8px',
      lineHeight: 'normal'
    },
    metaInfo: {
      gap: '8px'
    },
    infoContent: {
      gap: '8px'
    },
    metaChild: {
      fontSize: '12px'
    },
    aboutText: {
      fontSize: '16px'
    },
    instAbout: {
      fontSize: '12px'
    },
    highlightText: {
      fontSize: '16px'
    },
    highlightHeading: {
      fontSize: '12px'
    }
  }
}));

export default useAboutInstituteStyles;
